import { fetchPostApiNoAuth } from "./fetch";

export const addAlbumReservation = async (data) => {
  const res = await fetchPostApiNoAuth(`/temporaryalbum`, data);
  return res;
};
